import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inst-title" }, "솔리드 구조 검사", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "생산을 위한 3D 모델의 기본적인 조건을 만족하지 않은 경우입니다.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inst-subtitle" }, "[해결방법]", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, [
  /*#__PURE__*/_createTextVNode("· 3D캐드 Solid 모델링 설계 시 : 해당 검사가 실패하는 경우는 거의 없습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("· Surface 모델링 활용 시: Edge와 Vertex 등의 요소를 머지 하지 않아 모델이 정상적인 부피를 가지지 않는 경우 해당 검사가 실패합니다.")
], -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_5))
}